import React from 'react';
import classNames from 'classnames';

import useBem from '@/use/useBem';

type Props = {
  value: any;
  onChange: (a: string) => void;
  children: React.ReactNode;
  className?: string;
};

const Tabs: React.FC<Props> = (props) => {
  const { children: childrenProp, onChange, value, className } = props;
  const { bem } = useBem('tabs');

  const children = React.Children.map(childrenProp, (child, index) => {
    if (!React.isValidElement(child)) {
      return null;
    }

    const tab = child as React.ReactElement<{
      value?: string | number;
      selected?: boolean;
      onChange?: (a: string) => void;
    }>;

    const childValue =
      tab.props.value === undefined ? index : tab.props.value;
    const selected = value === childValue;

    return React.cloneElement(tab, {
      selected,
      onChange,
      value: childValue,
    });
  });

  return <div className={classNames([bem(''), className])}>{children}</div>;
};

export default Tabs;
